import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class MaintenanceService {
  path:string = "maintenance";

  constructor(private httpClient: HttpClient) { }

  findAll():Observable<any>{
    return this.httpClient.get(environment.baseURL + this.path);
  }

  create(entity:any):Observable<any>{
    return this.httpClient.post(environment.baseURL + this.path,entity);
  }

  edit(entity:any):Observable<any>{
    return this.httpClient.put(environment.baseURL + this.path+'/id;idDevice='+entity.idDevice+";idMaintenance="+entity.idMaintenance,entity);
  }

  remove(entity:any):Observable<any>{
    return this.httpClient.delete(environment.baseURL + this.path+'/id;idDevice='+entity.idDevice+";idMaintenance="+entity.idMaintenance);
  }

  findByUser(idUser:String):Observable<any>{
    return this.httpClient.get(environment.baseURL + this.path+"/findByUser/"+idUser);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/maintenance.service.ts